export const PARKING_CONFIG = {
  // Operating hours in Mountain Time (America/Denver)
  operatingHours: {
    open: 8,   // 8:00 AM
    close: 22, // 10:00 PM
    timezone: 'America/Denver',
  },

  // Maximum booking duration in hours
  maxDurationHours: 8,

  // Base rate per hour in USD
  baseRatePerHour: 5,

  // Property identifier
  propertyId: 'lumber-building',
  propertyName: 'Lumber Building',
} as const;
